import { css } from 'lit';

export default css`
  :host {
    --_bg-color: var(--sl-color-background-input-plain);
    --_bg-mix-color: var(--sl-color-background-input-interactive);
    --_bg-opacity: var(--sl-opacity-light-interactive-plain-idle);
    --_border: var(--sl-color-border-input);

    background: var(--_background);
    background: color-mix(in srgb, var(--_bg-color), var(--_bg-mix-color) calc(100% * var(--_bg-opacity)));
    border: var(--sl-size-borderWidth-default) solid var(--_border);
    border-radius: var(--sl-size-borderRadius-default);
    color: var(--sl-color-foreground-plain);
    cursor: text;
    display: block;
    outline: transparent solid var(--sl-size-outlineWidth-default);
    outline-offset: var(--sl-size-outlineOffset-default);
  }

  :host(:hover:not(:focus-within)) {
    --_bg-opacity: var(--sl-opacity-light-interactive-plain-hover);
  }

  :host(:focus) {
    outline-color: var(--sl-color-border-focused);
  }

  :host([disabled]) {
    background: var(--sl-color-background-disabled);
    border-color: var(--sl-color-border-disabled);
    color: var(--sl-color-foreground-disabled);
    pointer-events: none;
  }

  @media (prefers-reduced-motion: no-preference) {
    :host(:where(:hover, :focus-within)) {
      transition: 200ms ease-in-out;
      transition-property: background, border, color, outline-color;
    }
  }

  .mount {
    outline: none;
    padding: var(--sl-size-100);
  }

  h1 {
    margin-block: 0 var(--sl-size-100);
  }

  p {
    margin-block: 0 var(--sl-size-050);
  }
`;
